export function formatOrdinal(position: number): string {
  const safe = Math.max(1, Math.floor(position))
  const modulo100 = safe % 100
  if (modulo100 >= 11 && modulo100 <= 13) return `${safe}TH`
  if (safe % 10 === 1) return `${safe}ST`
  if (safe % 10 === 2) return `${safe}ND`
  if (safe % 10 === 3) return `${safe}RD`
  return `${safe}TH`
}
